// extracted by mini-css-extract-plugin
export var product = "page-module--product--90b3d";